import * as React from 'react';

import { Text } from '@components/common';
import { HamburgerSVG } from '@components/svgs';
import { useFixedSidebar } from '@hooks/useSidebar';

export const Header: React.FC = () => {
  const { toggle, open } = useFixedSidebar();

  return (
    <div className='tablet:flex-row tablet:space-y-0 tablet:justify-between flex w-full flex-col items-center space-y-4 border-b border-gray-200 bg-white px-6 py-2.5'>
      <div className='mobile:flex-nowrap flex w-full flex-1 flex-wrap items-center space-x-4 self-center overflow-hidden truncate text-sm'>
        <button
          name='Toggle sidebar'
          aria-expanded={open}
          aria-label='Toggle sidebar'
          className='text-gray-500 hover:text-gray-500 hover:underline'
          onClick={toggle}
        >
          <HamburgerSVG className='text-indigo-600' />
        </button>
        <Text h='400' color='gray-500'>
          /
        </Text>
        <Text h='400' color='gray-500'>
          Studies
        </Text>
        <Text h='400' color='gray-500'>
          /
        </Text>
        <Text h='400' bold>
          Intake
        </Text>
      </div>
    </div>
  );
};
